<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">{{ riderName }}</div>
      <div slot="sub-title">Ficha del Jinete</div>
      <div slot="right">
        <rider-indicators  v-if="rider" :rider="rider" :total-score="totalScore"></rider-indicators>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <div class="columns">
        <div class="column is-4 is-3-desktop">
          <card-component title="Ficha del Jinete" class="has-table has-mobile-sort-spaced">
            <div slot="headerRight" class="card-header-icon">
              <div class="buttons">
                <b-button @click="isEditModalActive = true" type="is-success">Editar</b-button>
              </div>
            </div>
            <rider-information class="card-content-padding" slot="content" v-if="rider && !isLoading" :rider="rider"></rider-information>
            <div style="min-height: 200px;" v-else-if="isLoading" slot="content">
              <b-loading :is-full-page="false" :active="isLoading" :can-cancel="false"></b-loading>
            </div>
          </card-component>
        </div>
        <div class="column">
          <card-component title="Información Detallada" :subtitle="subtitle" class="has-table has-mobile-sort-spaced" >
            <div slot="content">
              <b-tabs v-model="activeTab">
                <b-tab-item label="Asignaciones">
                  <rider-horses-table :rider-id="riderId" @number-result-changed="numberHorses = $event"></rider-horses-table>
                </b-tab-item>
                <b-tab-item label="Historial Evaluaciones">
                  <rider-scores-table :rider-id="riderId" @number-result-changed="numberScores = $event" @total-score-calculated="totalScoreChange"></rider-scores-table>
                </b-tab-item>
                <b-tab-item label="Historial Asignaciones">
                  <rider-history-assignments :rider-id="riderId" @number-result-changed="numberAssignments = $event"></rider-history-assignments>
                </b-tab-item>
                <!-- <b-tab-item label="Historial Lecciones">
                  <rider-history-lessons :rider-id="riderId"></rider-history-lessons>
                </b-tab-item> -->
              </b-tabs>
            </div>
          </card-component>
        </div>
      </div>
      <div class="columns">
        <div class="column is-full">
          <card-component title="Rendimiento por Lección" class="has-table has-mobile-sort-spaced">
            <rider-performance-chart class="card-content-padding" :rider-id="riderId" slot="content"></rider-performance-chart>
          </card-component>
        </div>
      </div>
    </section>
    <rider-form-modal :active.sync="isEditModalActive" :rider-id="riderId" @saved="getRider"/>
  </div>
</template>

<script>
import HeroBar from '@/components/HeroBar'
import CardComponent from '@/components/CardComponent'
import RiderService from '@/services/RiderService'
import RiderIndicators from './components/RiderIndicators'
import RiderScoresTable from './components/RiderScoresTable'
import RiderHorsesTable from './components/RiderHorsesTable'
import RiderHistoryAssignments from './components/RiderHistoryAssignments'
import RiderInformation from './components/RiderInformation'
import RiderPerformanceChart from './components/RiderPerformanceChart'
import RiderFormModal from './components/RiderFormModal'

export default {
  components: {
    HeroBar,
    CardComponent,
    RiderIndicators,
    RiderScoresTable,
    RiderHorsesTable,
    RiderHistoryAssignments,
    RiderInformation,
    RiderPerformanceChart,
    RiderFormModal
  },
  data () {
    return {
      isEditModalActive: false,
      activeTab: 0,
      riderId: this.$route.params.id,
      rider: null,
      isLoading: false,
      totalScore: 0,
      numberHorses: 0,
      numberScores: 0,
      numberAssignments: 0
    }
  },
  computed: {
    riderName () {
      return this.rider ? `${this.rider.name} ${this.rider.lastname}` : 'Jinete'
    },
    subtitle () {
      let subtitle
      let text
      if (this.activeTab === 0) {
        text = this.numberHorses === 1 ? 'caballo asignado' : 'caballos asignados'
        subtitle = `${this.numberHorses} ${text}`
      } else if (this.activeTab === 1) {
        text = this.numberScores === 1 ? 'evaluación realizada' : 'evaluaciones realizadas'
        subtitle = `${this.numberScores} ${text}`
      } else if (this.activeTab === 2) {
        text = this.numberAssignments === 1 ? 'asignacion historica' : 'asignaciones historicas'
        subtitle = `${this.numberAssignments} ${text}`
      }
      return subtitle
    }
  },
  created () {
    this.getRider()
  },
  methods: {
    async getRider () {
      this.isLoading = true
      let params = {
        'include[0]': 'horses',
        'include[1]': 'person'
      }
      let response = await RiderService.getRider(this.riderId, params)
      this.rider = response.data.data
      this.isLoading = false
    },
    totalScoreChange (value) {
      this.totalScore = value
    }
  },
  watch: {
    '$route.params.id' () {
      this.riderId = this.$route.params.id
    },
    riderId () {
      this.getRider()
    }
  }
}
</script>
